var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',{attrs:{"index":_vm.startIndex,"align":"center","header-align":"center","label":"#","type":"index","width":"60"}})
}
var staticRenderFns = []

export { render, staticRenderFns }